import { Token, tokenKey } from '../../atoms'
import { iconB64 } from '../../services/static_data'
import { Network } from '../../services/token.service'
import { getAMMContract, numberToCallParam } from '../../services/amm'
import { BulkCall, bulkCallContract } from '../../blockchainUtils/bulkCall'
import BigNumber from 'bignumber.js'
import store from '../store'
import { getWalletAddress } from '../../blockchainUtils/general'
import { decimal_int_to_float } from '../../blockchainUtils/math'
import { staticDataBucket } from '../../blockchainUtils'
import { TOKENS_ORDER } from '../../components/TokenSelectorNew/TokenSelectorNew'

export const WALLET_SUFFICIENT_BALANCE = { FALSE: 0, TRUE: 1, UNKNOWN: 2 }

export const initTokensList = async (network: Network): Promise<Record<string, Token>> => {
    // if (network === 'sepolia-alpha') return {}
    const all_data = { tokens: {}, pools: {} }
    // if (network === 'sepolia-alpha') all_data = { tokens: {}, pools: {} }
    const t = await fetch(`${staticDataBucket(network)}/data/tokens/static_data.json`)
    all_data['tokens'] = await t.json()

    let new_tokens = new Map<string, Token>()
    const tdata = all_data['tokens']
    const tokensPayload: Record<string, Token> = {}

    //@ts-ignore
    for (let i = 0; i < tdata.tokens.length; i++) {
        //@ts-ignore
        const d = tdata.tokens[i]
        let token: Token = {
            network: network,
            address: d.tokenAddress,
            id: i,
            name: d.tokenName,
            symbol: d.tokenSymbol,
            icon: d.tokenIcon,
            decimals: d.tokenDecimals,
            is_bluechip: d.isBluechip
        }

        if (!network.includes('mainnet') && iconB64.has(token.symbol)) {
            token.icon = iconB64.get(token.symbol) || ''
        }
        tokensPayload[token.address] = token
        new_tokens.set(tokenKey({ network, addr: d.tokenAddress }), token)
    }

    return tokensPayload
}

export async function loadTokenBalances(walletAddress: string, tokenAddresses: string[], network: Network) {
    const calls: BulkCall[] = []
    tokenAddresses.map((tokenAddress) => {
        calls.push({
            call: {
                contractAddress: tokenAddress,
                entrypoint: 'balanceOf',
                calldata: [numberToCallParam(walletAddress)]
            },
            responseParser: {
                kind: 'fixed',
                length: 2
            }
        })
    })

    const balances = (await bulkCallContract(network, calls)).map((res, index) => handleBalancePayload(res.result, tokenAddresses[index]))

    return balances
}

export async function loadTokenAllowances(walletAddress: string, tokenAddresses: string[], network: Network) {
    const calls: BulkCall[] = []

    tokenAddresses.map((tokenAddress) => {
        calls.push({
            call: {
                contractAddress: tokenAddress,
                entrypoint: 'allowance',
                calldata: [numberToCallParam(walletAddress), numberToCallParam(getAMMContract(network))]
            },
            responseParser: {
                kind: 'fixed',
                length: 2
            }
        })
    })
    // const allowances = (await bulkCallContract(network, calls)).map((res, index) => handleAlowancePayload(res.result, tokenAddresses[index]))

    // console.log('allowances ', allowances)
}

function handleBalancePayload(rawResp: string[], tokenAddress: string) {
    const balance = new BigNumber(rawResp[0]).toString()
    return { balance: balance, tokenAddress: tokenAddress }
}

export function getToken(network: string, address: string): Token | undefined {
    const tokenStore = store.getState().tokens
    try {
        if (tokenStore.tokens[network]) {
            const token = tokenStore.tokens[network][address]
            return token
        }
        return undefined
    } catch (error) {
        console.log('YSYS error=', error)
        return undefined
    }
}

export function getTokenBalance(network: string, tokenAddress: string): string {
    const balances = store.getState().tokens.balance
    try {
        const balance = balances[network][tokenAddress]
        return balance
    } catch (error) {
        return '0'
    }
}

const is_dev = (): boolean => {
    //return (process.env.NODE_ENV) === 'development'
    return false
}

export const toWei = (amount: string, token: Token): string => {
    return new BigNumber(amount).multipliedBy(new BigNumber(10).pow(token.decimals)).toFixed(0)
}

// from integer wei to "1.000" display format
export const toDisplay = (amountWei: BigNumber, token: Token): string => {
    return amountWei.dividedBy(new BigNumber(10).pow(token.decimals)).toFixed(token.decimals)
}

export const toDisplayDecimals = (amountWei: BigNumber, decimals: number): string => {
    return amountWei.dividedBy(new BigNumber(10).pow(decimals)).toFixed(decimals)
}

export const toDecimals = (amountWei: BigNumber, decimals: number): string => {
    return amountWei.dividedBy(new BigNumber(10).pow(decimals)).toFixed(decimals)
}

export const toUint256 = (amount: string): Array<String> => {
    const x = BigNumber(amount)
    const u128max = BigNumber(2).pow(128)

    const lown = x.modulo(u128max)
    const highn = x.dividedBy(u128max).decimalPlaces(0, BigNumber.ROUND_FLOOR)
    return [lown.toFixed(0), highn.toFixed(0)]
}

export const fromUint256 = (low: string, high: string): BigNumber => {
    const u128max = new BigNumber(2).pow(128)
    const x = BigNumber(low).plus(BigNumber(high).multipliedBy(u128max))
    return x
}

export const isSufficientBalanceInWallet = (network: string, token: string, amount: string) => {
    if (is_dev()) console.log('amm: isSufficientBalanceInWallet, token=', token, ' amount=', amount)

    let activeAccount: string = getWalletAddress()
    const balance = getTokenBalance(network, token)

    if (!activeAccount) return WALLET_SUFFICIENT_BALANCE.UNKNOWN
    if (!token) return WALLET_SUFFICIENT_BALANCE.UNKNOWN
    if (!amount) return WALLET_SUFFICIENT_BALANCE.TRUE
    // if (!tud) return WALLET_SUFFICIENT_BALANCE.UNKNOWN
    if (balance === '0') return WALLET_SUFFICIENT_BALANCE.FALSE

    // The actual check:
    let tokenWalletAmount = decimal_int_to_float(network, token, balance)

    if (new BigNumber(amount).isPositive() && new BigNumber(amount).lte(new BigNumber(tokenWalletAmount))) return WALLET_SUFFICIENT_BALANCE.TRUE

    return WALLET_SUFFICIENT_BALANCE.FALSE
}

// const TOKENS_ORDER: Record<string, number> = { ETH: 0, DAI: 1, USDC: 2, WBTC: 3, USDT: 4 }

function tokenOrder(key_and_token: any) {
    const tokenSym = key_and_token.symbol
    return TOKENS_ORDER[tokenSym] ?? 100
}

function sortTokens(tokens: Token[]) {
    const toks = tokens.map((a) => {
        return { ...a }
    })
    toks.sort((e1, e2) => {
        return tokenOrder(e1) - tokenOrder(e2)
    })
    return toks
}

export function getSortedList(tokens: Token[], otherToken: string, noMeme: boolean = false) {
    let tokensList: any = [...sortTokens(tokens)]
    const list: Token[] = []
    tokensList.forEach((value: any) => {
        const address = value.address
        if (noMeme && address === '0x6f15ec4b6ff0b7f7a216c4b2ccdefc96cbf114d6242292ca82971592f62273b') return
        else if (otherToken && otherToken.toLowerCase() !== address.toLowerCase()) {
            list.push(value)
        } else if (!otherToken) {
            list.push(value)
        }
    })
    return list
}

export function removeLeadingZeros(hexString: string): string {
    if (!hexString) return hexString
    // Check if the string starts with '0x' or '0X'
    if (hexString.startsWith('0x') || hexString.startsWith('0X')) {
        // Remove the '0x', then remove leading zeros, but ensure at least one zero remains
        return '0x' + hexString.substring(2).replace(/^0+(?=[0-9a-fA-F])/, '')
    } else {
        // If it doesn't start with '0x', just remove leading zeros, ensuring at least one zero remains
        return hexString.replace(/^0+(?=[0-9a-f])/, '')
    }
}
